<fieldset>
    <legend>{{groupTitle}}</legend>
    <smart-icon (click)="onDeletionClicked($event)" name="redTrash" class="delete-icon" title="delete"></smart-icon>
    <ng-content></ng-content>
</fieldset>
